import { useSelector } from 'react-redux';

const DisclosureDetailsFromCompanyDetailsWidget = ({ token }) => {
	const companyDetailsResponse = useSelector(({ fuse }) => fuse.form.companyDetailsResponse);
	const channelCompanyDisclosure = useSelector(({ fuse }) => fuse.form.channelSettings?.value?.company?.disclosure);

	return (
		<div>
			<div className="flex flex-col">
				<div
					dangerouslySetInnerHTML={{
						__html: token === 'TOKEN' ? companyDetailsResponse?.value?.disclosure : channelCompanyDisclosure
					}}
				/>
			</div>
		</div>
	);
};

export default DisclosureDetailsFromCompanyDetailsWidget;
